function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { createSlice } from '@reduxjs/toolkit';
export var initialState = {
    isOpen: false
};
export var popupSlice = createSlice({
    name: 'popup',
    initialState: initialState,
    reducers: {
        openPopup: function openPopup(state) {
            state.isOpen = true;
        },
        closePopup: function closePopup(state) {
            state.isOpen = false;
        },
        setPopupProps: function setPopupProps(state, action) {
            var _action_payload = action.payload, componentProps = _action_payload.componentProps, componentName = _action_payload.componentName;
            state.componentName = componentName;
            state.componentProps = componentProps;
        },
        updatePopupProps: function updatePopupProps(state, action) {
            var componentProps = action.payload;
            state.componentProps = _object_spread({}, state.componentProps, componentProps);
        },
        resetPopup: function resetPopup(state) {
            state.isOpen = false;
            state.componentName = undefined;
            state.componentProps = {};
        }
    }
});
var _popupSlice_actions = popupSlice.actions;
export var closePopup = _popupSlice_actions.closePopup, openPopup = _popupSlice_actions.openPopup, resetPopup = _popupSlice_actions.resetPopup, setPopupProps = _popupSlice_actions.setPopupProps, updatePopupProps = _popupSlice_actions.updatePopupProps;
